import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class BillingMethodLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            billingMethod: this.props.value || '',
            masculine: this.props.masculine || false,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            billingMethod: nextProps.value || '',
            masculine: nextProps.masculine || false,
        })
    }

    render() {
        switch (this.state.billingMethod) {
            case "one-time":
                return <FormattedMessage
                    id="common.billing_method.label.one_time"
                    defaultMessage="One time"
                />
            case "monthly":
                if (this.state.masculine) {
                    return <FormattedMessage
                        id="common.billing_method.label.monthly_masculine"
                        defaultMessage="Monthly"
                    />
                } else {
                    return <FormattedMessage
                        id="common.billing_method.label.monthly"
                        defaultMessage="Monthly"
                    />
                }

            case "yearly":
                if (this.state.masculine) {
                    return <FormattedMessage
                        id="common.billing_method.label.yearly_masculine"
                        defaultMessage="Yearly"
                    />
                } else {
                    return <FormattedMessage
                        id="common.billing_method.label.yearly"
                        defaultMessage="Yearly"
                    />
                }

        }
        return ''
    }
}

export default BillingMethodLabel





// WEBPACK FOOTER //
// ./src/product/billing-method/label.component.jsx